module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-03.43512b33.jpg";